import plant from '../assets/floorPlan/plant.svg';
import block from '../assets/floorPlan/block.svg';
import couch from '../assets/floorPlan/couch.svg';
import couch2 from '../assets/floorPlan/couch2.svg';
import couch3 from '../assets/floorPlan/couch3.svg';
import bar from '../assets/floorPlan/bar.svg';
import bar2 from '../assets/floorPlan/bar2.svg';
import bar3 from '../assets/floorPlan/bar3.svg';
import stool from '../assets/floorPlan/stool.svg';

export const TABLE_TYPE = "table";
export const ARTEFACT_TYPE = "artefact";

export const RESIZABLE_TYPES = [
    ARTEFACT_TYPE,
];

export const PX_PER_M = 40;

export const ARTEFACTS_TYPES = {
    BLOCK: "BLOCK",
    PLANT: "PLANT",
    COUCH: "COUCH",
    COUCH2: "COUCH2",
    COUCH3: "COUCH3",
    BAR: "BAR",
    BAR2: "BAR2",
    BAR3: "BAR3",
    STOOL: "STOOL",
};

export const ARTEFACTS_TYPES_LIST = Object.values(ARTEFACTS_TYPES);

export const ARTEFACT_SVGs = {
    [ARTEFACTS_TYPES.BLOCK]: block,
    [ARTEFACTS_TYPES.PLANT]: plant,
    [ARTEFACTS_TYPES.COUCH]: couch,
    [ARTEFACTS_TYPES.COUCH2]: couch2,
    [ARTEFACTS_TYPES.COUCH3]: couch3,
    [ARTEFACTS_TYPES.BAR]: bar,
    [ARTEFACTS_TYPES.BAR2]: bar2,
    [ARTEFACTS_TYPES.BAR3]: bar3,
    [ARTEFACTS_TYPES.STOOL]: stool,
}

export const RESIZABLE_ARTEFACTS = [
    ARTEFACTS_TYPES.BLOCK,
];


export const ARTEFACTS_TYPES_TEXT = {
  [ARTEFACTS_TYPES.PLANT]: 'settings:artefact.types.plant',
  [ARTEFACTS_TYPES.BLOCK]: 'settings:artefact.types.block',
  [ARTEFACTS_TYPES.COUCH]: 'settings:artefact.types.couch',
  [ARTEFACTS_TYPES.COUCH2]: 'settings:artefact.types.couch2',
  [ARTEFACTS_TYPES.COUCH3]: 'settings:artefact.types.couch3',
  [ARTEFACTS_TYPES.STOOL]: 'settings:artefact.types.stool',
  [ARTEFACTS_TYPES.BAR]: 'settings:artefact.types.bar',
  [ARTEFACTS_TYPES.BAR2]: 'settings:artefact.types.bar2',
  [ARTEFACTS_TYPES.BAR3]: 'settings:artefact.types.bar3',
};

export const ARTEFACTS_OPTIONS = Object.entries(ARTEFACTS_TYPES)
    .map(([key, value]) => ({
        key,
        value,
        text: ARTEFACTS_TYPES_TEXT[key],
        image: {
            centered: true,
            src: ARTEFACT_SVGs[key],
        },
    }))


// WEBPACK FOOTER //
// ./src/constants/floorPlan.js